<template lang="">
  <footer class="bg-[#000] pt-[10rem] pb-[40px]">
    <div class="max-w-[1440px] xl:px-[86px] px-4 mx-auto">
      <div class="flex flex-col md:grid grid-cols-12 gap-8">
        <div
          class="lg:col-span-4 col-span-12 flex flex-col items-start justify-between mb-5 h-full"
        >
          <div class="logo w-full">
            <img
              alt="fitXpert logo website logo"
              class="w-full my-4 md:my-0 object-cover max-w-sm"
              src="https://fitexpert-landing.codebase-product.com/storage/203/Logo-Fitxpert.svg"
            />
          </div>
          <div class="text-bg hidden lg:block">
            <h2 class="text-3xl mb-3 opacity-80 mt-7"></h2>
            <h6 class="text-sm opacity-80">info@fitexpert.team</h6>
            <h6 class="text-sm opacity-80 md:hidden">
              Dubai - JLT- Almas tour
            </h6>
          </div>
        </div>
        <div
          class="lg:col-span-8 col-span-12 grid grid-cols-12 gap-4 lg:gap-[2rem]"
        >
          <div class="col-span-12 md:col-span-6 lg:col-span-3">
            <ul class="w-full">
              <li
                class="text-[#fff000] mb-2 lowercase first-letter:uppercase text-base"
              >
                Quick links
              </li>
              <li class="footerLink">
                <router-link to="/"> Home </router-link>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Features
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  About us
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  contact us
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Pricing
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Terms and conditions
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Privacy Policy
                </div>
              </li>
            </ul>
          </div>
          <div class="col-span-12 md:col-span-6 lg:col-span-3">
            <ul class="w-full">
              <li
                class="text-[#fff000] mb-2 lowercase first-letter:uppercase text-base"
              >
                Business Growth
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Unlimited Co-workers
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Custom Branding
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Reports
                </div>
              </li>
            </ul>
          </div>
          <div class="col-span-12 md:col-span-6 lg:col-span-3">
            <ul class="w-full">
              <li
                class="text-[#fff000] mb-2 lowercase first-letter:uppercase text-base"
              >
                Client Engagement
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Diet Plan
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Workouts Programs
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Progress sharing
                </div>
              </li>
            </ul>
          </div>
          <div class="col-span-12 md:col-span-6 lg:col-span-3">
            <ul class="w-full">
              <li
                class="text-[#fff000] mb-2 lowercase first-letter:uppercase text-base"
              >
                Client Management
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Subscription Management
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Client Profile
                </div>
              </li>
              <li class="footerLink">
                <div
                  class="opacity-[0.42] transition-all hover:text-[#fff000] hover:opacity-100 cursor-pointer"
                >
                  Leads Management
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-span-12 lg:hidden block">
          <div class="text-bg">
            <h2 class="text-3xl mb-3 opacity-80 mt-7"></h2>
            <h6 class="text-sm opacity-80">info@fitexpert.team</h6>
            <h6 class="text-sm opacity-80 mt-2">Dubai - JLT- Almas tour</h6>
          </div>
        </div>
        <div class="col-span-12">
          <div
            class="flex items-center md:flex-row flex-col justify-between mt-2 flex-wrap gap-2"
          >
            <h6 class="text-sm opacity-50 hidden lg:block flex-1">
              Dubai - JLT- Almas tour
            </h6>
            <div
              class="text-gray-400 text-sm text-bg md:text-start text-center order-1"
            >
              FITXPERT © 2023 All copyrights reserved.
            </div>
            <div
              class="flex gap-[12px] md:flex-1 md:justify-end order-0 md:order-2"
            >
              <a
                referrerpolicy="origin-when-cross-origin"
                href="https://www.facebook.com/fitxpert.team"
                target="_blank"
                title="facebook"
                class="socialLink bg-[#141414] rounded-full shadow-2xl w-[36px] h-[36px] flex items-center justify-center transition-all hover:bg-[#fff00024]"
                ><span
                  class="icon h-[24px] w-[24px] overflow-hidden rounded-full relative"
                  ><img
                    src="https://fitexpert-landing.codebase-product.com/storage/317/Facebook.svg"
                    width="24"
                    height="24"
                    alt="facebook"
                    class="absolute top-0 h-[20px] w-[20px]"
                    style="
                      object-fit: contain;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                    " /></span></a
              ><a
                referrerpolicy="origin-when-cross-origin"
                href="https://www.instagram.com/fitexpert.team/"
                target="_blank"
                title="instagram"
                class="socialLink bg-[#141414] rounded-full shadow-2xl w-[36px] h-[36px] flex items-center justify-center transition-all hover:bg-[#fff00024]"
                ><span
                  class="icon h-[24px] w-[24px] overflow-hidden rounded-full relative"
                  ><img
                    src="https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg"
                    width="24"
                    height="24"
                    alt="instagram"
                    data-nuxt-img=""
                    sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 400px"
                    srcset="
                      https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg   1w,
                      https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg   2w,
                      https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg 320w,
                      https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg 400w,
                      https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg 640w,
                      https://fitexpert-landing.codebase-product.com/storage/318/Instagram.svg 800w
                    "
                    class="absolute top-0 h-[20px] w-[20px]"
                    style="
                      object-fit: contain;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                    " /></span></a
              ><a
                referrerpolicy="origin-when-cross-origin"
                href="https://www.youtube.com/channel/UCTqYda-9yVLdvVuE6ttGeFQ"
                target="_blank"
                title="youtube"
                class="socialLink bg-[#141414] rounded-full shadow-2xl w-[36px] h-[36px] flex items-center justify-center transition-all hover:bg-[#fff00024]"
                ><span
                  class="icon h-[24px] w-[24px] overflow-hidden rounded-full relative"
                  ><img
                    src="https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg"
                    width="24"
                    height="24"
                    alt="youtube"
                    data-nuxt-img=""
                    sizes="(max-width: 640px) 100vw, (max-width: 768px) 50vw, 400px"
                    srcset="
                      https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg   1w,
                      https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg   2w,
                      https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg 320w,
                      https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg 400w,
                      https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg 640w,
                      https://fitexpert-landing.codebase-product.com/storage/319/Youtube.svg 800w
                    "
                    class="absolute top-0 h-[20px] w-[20px]"
                    style="
                      object-fit: contain;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                    " /></span
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<style scoped lang="scss">
.router-link-active,
.router-link-exact-active {
  color: #fff000;
  position: relative;
  cursor: pointer;
  &:after {
    position: absolute;
    content: "";
    bottom: -27%;
    left: 0;
    height: 2px;
    width: 18%;
    background-color: #fff000;
  }
}
.footerLink {
  margin-bottom: 7px !important;
}
</style>
